import React from 'react';
import classNames from 'classnames';

import IconFilter from 'components/icons/iconFilter2';
import { colorGray, colorWhite } from 'styles/layout/colors';
import MobileOnly from 'components/consumer/MobileOnly';

const MobileProductFiltersButton = ({ onClick, items }) => {
  const activeFilterCount = items.filter(item => item.isRefined).length;
  const hasActiveFilters = activeFilterCount > 0;

  return (
    <MobileOnly>
      <button
        type="button"
        className={classNames(
          'md:hidden text-sm font-bold items-center rounded-sm flex justify-center mr-[6px] p-3 border-[1px] max-h-12',
          {
            'bg-brand border-brand text-white': hasActiveFilters,
            'bg-white border-gray-light3 text-gray': !hasActiveFilters,
          }
        )}
        onClick={onClick}
      >
        <IconFilter
          className="mr-[6px]"
          color={hasActiveFilters ? colorWhite : colorGray}
        />

        <span
          className={classNames('h-full', {
            'text-gray': !hasActiveFilters,
            'text-white': hasActiveFilters,
          })}
        >
          <span>Filters</span>
          {activeFilterCount > 0 && ` (${activeFilterCount})`}
        </span>
      </button>
    </MobileOnly>
  );
};

export default MobileProductFiltersButton;
